import { Box, Skeleton, Stack } from "@vapor/react-material";

export const BoxSkeleton = ({ n = 2 }) => {
    return (
        <>
            {Array(n)
                .fill(0)
                .map((_, i) => (
                    <Box
                        key={`sectional-skeleton-${i}`}
                        sx={{
                            border: "1px solid rgb(201, 217, 232)",
                            position: "relative",
                            borderRadius: "8px",
                            padding: "28px 32px",
                            margin: "16px 0px"
                        }}
                    >
                        <Stack spacing={3}>
                            <Skeleton variant="text" width={"50%"} height={48} />
                            <Box>
                                <Skeleton variant="text" width={"40%"} />
                                <Skeleton variant="text" width={"45%"} />
                            </Box>
                            <Stack direction={"row"} spacing={4}>
                                <Box>
                                    <Skeleton variant="text" width={270} />
                                    <Skeleton variant="text" width={300} />
                                </Box>
                                <Box>
                                    <Skeleton variant="text" width={250} />
                                    <Skeleton variant="text" width={270} />
                                </Box>
                            </Stack>
                        </Stack>
                    </Box>
                ))}
        </>
    );
};
